import { Box, Paper, useTheme } from '@material-ui/core';
import React from 'react';
import { AlertButton, CenterBox } from '../styled';
import Typography from '../../../components/common/Typography';
import { Divider } from '../../../components/common/Divider';
import { Button } from '../../../components/common/Buttons';
import { useTrans } from '../../../services/i18n';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { alpha as fade } from '@material-ui/core/styles/colorManipulator';
import styles from '../styles.module.css';

function PlanCard({
  name = 'Not Set',
  price = '',
  isSubscribed = false,
  onSubscribeClick,
  priceColor = 'success',
  buttonColor = 'primary',
  buttonText,
  canSubscribe = true,
  priceIntervalText = '',
  priceDescription = '',
  redirectUrl = undefined,
  isPromotion = false,
  originalPrice = null,
  promotionText = null,
}) {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const { trans } = useTrans();

  const mobileStyle = isMobile ? { width: '100%', marginBottom: '2rem' } : { width: '100%' };

  const buttonStyle = {
    padding: '1.5rem 1.75rem',
    borderRadius: '6.25rem',
    fontSize: '1rem',
    lineHeight: '1.28rem',
    textTransform: 'uppercase',
  };

  return (
    <Paper 
      style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        height: '100%', 
        ...mobileStyle,
        position: 'relative',
        overflow: 'visible'
      }}
      className={isPromotion ? styles.promotionCard : ''}
    >
      <Paper
        style={{ backgroundColor: '#f1f3f9', padding: '2rem 0', borderRadius: '1rem 1rem 5rem 5rem' }}
        elevation={0}
      >
        <CenterBox style={{ padding: '.75rem 0' }}>
          <Box>
            <Typography variant={'h1'} weight="600" color={priceColor} component="span">
              {name}
            </Typography>
          </Box>
        </CenterBox>
      </Paper>

      <CenterBox style={{ padding: isMobile ? '2rem 0' : '4rem 0', flex: 1 }}>
        {isPromotion && originalPrice ? (
          <>
            {/* Original price crossed out */}
            <Typography 
              variant={'h6'} 
              weight="400" 
              color="hint" 
              className={styles.strikethrough}
              style={{ 
                marginBottom: '0.5rem',
                fontSize: '20px'
              }}
            >
              {trans(originalPrice)}
              <Typography variant={'body2'} weight="400" color="hint" component="span" style={{ fontSize: '16px' }}>
                {' ' + priceIntervalText}
              </Typography>
            </Typography>
            
            {/* New promotional price */}
            <Typography 
              variant={'h1'} 
              weight="800" 
              className={styles.promotionalPrice}
              style={{ 
                marginBottom: '.5rem', 
                fontSize: '35px',
                position: 'relative'
              }}
            >
              {trans(price)}
              <Typography variant={'h4'} weight="500" color="hint" component="span" style={{ fontSize: '24px' }}>
                {' ' + priceIntervalText}
              </Typography>
            </Typography>
            
            {/* Savings amount */}
            <Typography 
              variant={'h6'} 
              weight="600" 
              color="success" 
              style={{ 
                marginBottom: '.5rem',
                fontSize: '18px'
              }}
            >
              Save $499!
            </Typography>
          </>
        ) : (
          <Typography variant={'h1'} weight="800" color={priceColor} style={{ marginBottom: '.5rem', fontSize: '35px' }}>
            {trans(price)}
            <Typography variant={'h4'} weight="500" color="hint" component="span" style={{ fontSize: '24px' }}>
              {' ' + priceIntervalText}
            </Typography>
          </Typography>
        )}

        <Typography
          variant={isMobile ? 'h5' : 'h6'}
          weight="700"
          color={isPromotion ? 'error' : buttonColor}
          style={{
            backgroundColor: fade(theme.palette[isPromotion ? 'error' : buttonColor].main, 0.06),
            padding: '.5rem .8rem',
            borderRadius: '3.75rem',
          }}
        >
          {isPromotion ? 'USFCR Anniversary Special' : priceDescription}
        </Typography>

        {isMobile && (
          <Box style={{ marginTop: '2rem' }}>
            {isSubscribed ? (
              <AlertButton variant="outlined" color={buttonColor} theme={theme} style={buttonStyle}>
                {trans('current-plan')}
              </AlertButton>
            ) : (
              <Button
                variant="contained"
                color={buttonColor}
                onClick={onSubscribeClick}
                size="large"
                style={buttonStyle}
              >
                {buttonText ? buttonText : trans('subscribe')}
              </Button>
            )}
          </Box>
        )}
      </CenterBox>

      {canSubscribe && !isMobile && (
        <Box>
          <Divider light />
          <CenterBox style={{ padding: '1.5rem 0 1rem' }}>
            {isSubscribed ? (
              <AlertButton variant="outlined" color={buttonColor} theme={theme} style={buttonStyle}>
                {trans('current-plan')}
              </AlertButton>
            ) : (
              <Button variant="contained" color={buttonColor} onClick={onSubscribeClick} style={buttonStyle}>
                {buttonText ? buttonText : trans('subscribe')}
              </Button>
            )}
          </CenterBox>
        </Box>
      )}
    </Paper>
  );
}

export default PlanCard;
